export default {
  en: {
    editTransfer: 'Edit Transfer',
    transferList: 'Transfer',
    name: 'Name',
    price: 'Price',
    unit: 'Unit',
    minPax: 'Min Pax',
    maxPax: 'Max Pax',
    status: 'Status',
    conditionDetail: 'Condition',
    transferUnitTypeCar: 'Per Car',
    transferUnitTypePerPerson: 'Per Person',
    updateTransfer: 'Save Changes',
    cancel: 'Cancel',
    updateTransferSuccessTitle: 'Success',
    updateTransferSuccessMessage: 'Add Transfer Success.'
  },
  th: {
    editTransfer: 'แก้ไขรถรับส่ง',
    transferList: 'รถรับส่ง',
    name: 'ชื่อ',
    price: 'ราคา',
    unit: 'หน่วย',
    minPax: 'จำนวนขั้นต่ำ',
    maxPax: 'จำนวนสูงสุด',
    status: 'สถานะ',
    conditionDetail: 'เงื่อนไขและรายละเอียด',
    transferUnitTypeCar: 'ต่อคัน',
    transferUnitTypePerPerson: 'ต่อคน',
    updateTransfer: 'บันทึก',
    cancel: 'ยกเลิก',
    updateTransferSuccessTitle: 'สำเร็จ',
    updateTransferSuccessMessage: 'เพิ่มรถรับส่งสำเร็จ'
  }
}
